import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/governance/"
)({
  component: () => <Navigate to="/governance/elections" />,
})
